/**
 * This is the JS file for the Segment tracking functions
 */

// check bucket variable

analytics.ready(function() {
	if ($.cookie('already_identify') === undefined || $.cookie('already_identify') !== $.cookie('www_bucket'))
	{
		var segmentIDValue;
		segmentIDValue = analytics.user().id();
		if (segmentIDValue !== null && segmentIDValue.length > 0) {
			// exist, ok
			segmentIDValue = analytics.user().id();
		} else {
			// does not exist, switch to anonymous
			su_anonymous_id = analytics.user().anonymousId();
			segmentIDValue = su_anonymous_id;
		}

		var bucket_value = "";
		if ($.cookie('www_bucket')) {

			bucket_value = parseInt($.cookie('www_bucket'));
			if (!isNaN(bucket_value)) {

				$.cookie('already_identify', bucket_value);

				analytics.identify('', { bucket: bucket_value }, {
					integrations: {'all': true, 'Customer.io': true, 'Amplitude': false, 'HubSpot': false}
				});
			}
		}
	}
});

// Pricing "Clicked plan"

// Free
$( ".men__plan--free .js-gaevent-pricing" ).click(function() {
	analytics.track('GAevent', {
		eventCategory: 'pricing',
		eventAction: 'free plan',
		eventLabel: '//'
	});

	dataLayer.push({
		event: 'virtualPageview',
		virtualPageURL: window.location.pathname + 'step-2',
		virtualPageTitle: document.title + ' - Step 2'
	});

});

// Solo
$( ".men__plan--so .js-gaevent-pricing" ).click(function() {
	analytics.track('GAevent', {
		eventCategory: 'pricing',
		eventAction: 'solo plan',
		eventLabel: '//'
	});

	dataLayer.push({
		event: 'virtualPageview',
		virtualPageURL: window.location.pathname + 'step-2',
		virtualPageTitle: document.title + ' - Step 2'
	});
});

// Starter
$( ".men__plan--st .js-gaevent-pricing" ).click(function() {
	analytics.track('GAevent', {
		eventCategory: 'pricing',
		eventAction: 'pro plan',
		eventLabel: '//'
	});

	dataLayer.push({
		event: 'virtualPageview',
		virtualPageURL: window.location.pathname + 'step-2',
		virtualPageTitle: document.title + ' - Step 2'
	});

});

// Enterprise
$( ".men__plan--comp .js-gaevent-pricing" ).click(function() {
	analytics.track('GAevent', {
		eventCategory: 'pricing',
		eventAction: 'enterprise plan',
		eventLabel: '//'
	});

	dataLayer.push({
		event: 'virtualPageview',
		virtualPageURL: window.location.pathname + 'step-2',
		virtualPageTitle: document.title + ' - Step 2'
	});

});

// Global tracking
$( ".js-gaevent" ).click(function() {
	var trackingData = {};
	if ($(this).data('event-category')) {
		trackingData.eventCategory = $(this).data('event-category');
	}
	if ($(this).data('event-action')) {
		trackingData.eventAction = $(this).data('event-action');
	}
	if ($(this).data('event-label')) {
		trackingData.eventLabel = $(this).data('event-label');
	}
	analytics.track('GAevent', trackingData);
});

$( ".js-gaevent-login" ).click(function() {
	// need a separate event since the properties can't be added directly from WP Menu
	analytics.track('GAevent', {
		eventCategory : 'header',
		eventAction :'login',
		eventLabel: '//'
	});
});


$('body').on('click', function(e){
	if ($(e.target).hasClass('hs-cta-img')){
		// console.log(e.target);
		// console.log('cta clicked');
		var data = {
			eventCategory : 'blog',
			eventAction : 'in-article cta',
			eventLabel : '//'
		};
		analytics.track('GAevent', data);
	}
});
